
import HTMLReactParser from 'html-react-parser';
import React from 'react';

import { useFormContext } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { capitalize } from '../utils';
import RegistrationFormInput from './RegistrationFormInput';

const RegistrationFormRow = ({
    labelClassName,
    name,
    placeholder,
    textLabel,
    inputType,
    required = true,
    inputOptions,
    helper,
    isRegister,
    accept,
    defaultValue,
    fieldValue,
    onChange,
    children,
    maxLength
}) => {

    const { t, i18n } = useTranslation();

    const { formState, } = useFormContext();

    const [showEditSection, setShowEditSection] = React.useState(false);

    return <div className={`flex mb-1 py-2 w-full ${formState.errors[name] ? 'bg-red-50 dark:bg-red-900/20 text-dark' : ''}`}>

        <label htmlFor={name} className={`${labelClassName} w-1/4 items-center py-2 px-3 text-gray-700 dark:text-neutral-200`}>
            {HTMLReactParser(capitalize(textLabel ?? placeholder ?? name))}
            {required && <span className="p-2 text-red-600 dark:text-red-400">*</span>}
        </label>

        <div className="w-3/4 flex flex-col">
            {showEditSection ? defaultValue : <>
                <RegistrationFormInput
                    helper={helper}
                    onChange={onChange}
                    defaultValue={defaultValue}
                    fieldValue={fieldValue}
                    accept={accept}
                    isRegister={isRegister}
                    inputOptions={inputOptions}
                    name={name}
                    inputType={inputType}
                    required={required}
                    maxLength={maxLength}
                    placeholder={inputType !== 'textarea' ? capitalize(placeholder) : ''} />
                {formState.errors[name] && <div className="text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded p-2 my-2">{t('form.alerts.veuillez_renseigner')} {HTMLReactParser(capitalize(placeholder))}</div>}
                {!maxLength && <div className="text-gray-400 dark:text-neutral-500 text-sm">{HTMLReactParser(helper ?? "")}</div>}
                {children}
            </>}
        </div>
    </div>
}

export default RegistrationFormRow;

